import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { UserManagementService } from 'src/app/Service/user-management.service';

@Component({
  selector: 'app-add-news',
  templateUrl: './add-news.component.html',
  styleUrls: ['./add-news.component.scss'],
  providers: [DatePipe],
})
export class AddNewsComponent implements OnInit {
  form: FormGroup;
  submitted = false;
  imageSrc: string | ArrayBuffer;
  uploadedImage: File;
  isSingleUploaded = false;

  disable = false;
  response;

  reg = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
  regexStr = '^[0-9]*$';
  today = new Date();
  currentD = this.datepipe.transform(this.today, 'dd/MM/yyyy');
  languages = [];
  languageList: any = [
    { value: 'te', viewValue: 'Telugu' },
    { value: 'ta', viewValue: 'Tamil' },
    { value: 'kn', viewValue: 'Kannada' },
    { value: 'ml', viewValue: 'Malayalam' },
    { value: 'en', viewValue: 'English' },
    { value: 'hi', viewValue: 'Hindi' },
  ];

  constructor(
    private router: Router,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private datepipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      newsTitle: ['', [Validators.required]],
      newsSource: ['', [Validators.required]],
      attachlink: ['', [Validators.required]],
      languages: ['', [Validators.required]],
      remark: [''],
      date: [new Date()],
      image: new FormControl(''),
    });
  }
  get attach_url() {
    return this.form.get('attachlink');
  }

  checkFileValidation(file) {
    let imageName = file.name;
    let fileExtensionError: boolean;
    // check file type
    var allowedExtensions = [
      'jpg',
      'jpeg',
      'png',
      'JPG',
      'JPEG',
      'JFIF',
      'BMP',
      'SVG',
    ];
    let fileExtension = imageName.split('.').pop();

    if (this.isInArray(allowedExtensions, fileExtension)) {
      return false;
    } else {
      return true;
    }
  }

  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }

  onSubmit() {
    if (this.form.valid) {
      if (this.form.value.attachlink != '') {
        var pattern = new RegExp(this.reg);
        var result = pattern.test(this.form.value.attachlink);
        if (result == false) {
          alert('Please enter valid attach link');
          return false;
        }
      }
      if (this.form.value.image === '') {
        this.toastr.error('Please select Image');
        return false;
      }
      this.spinner.show();
      const formData: FormData = new FormData();
      const changeDate = this.datepipe.transform(
        this.form.controls.date.value,
        'yyyy-MM-ddTHH:mm:ss.sss'
      );
      formData.append('Title', this.form.get('newsTitle').value),
        formData.append('Image', this.form.get('image').value),
        formData.append('Source', this.form.get('newsSource').value),
        formData.append('PublishDate', changeDate),
        formData.append('NewsLink', this.form.get('attachlink').value),
        formData.append('Remark', this.form.get('remark').value),
        formData.append('Languages', this.form.get('languages').value),
        this._userService.postNews(formData).subscribe((data) => {
          this.response = data;

          if (data) {
            this.spinner.hide();
          }
          this.toastr.success(this.response.result.message);
        });
      this.router.navigateByUrl('', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/add-news']);
      });
    } else {
      this.toastr.error('please fill the details');
    }
  }

  listPage(): void {
    this.router.navigate(['/news-historical-data']);
  }
  get f() {
    return this.form.controls;
  }

  getToday(): string {
    return new Date().toISOString().split('T')[0];
  }
  newsFileSelected(event) {
    if (this.checkFileValidation(event.target.files[0])) {
      this.toastr.error('Please upload correct file');
    } else {
      this.uploadedImage = event.target.files[0];
      this.form.get('image')?.setValue(this.uploadedImage);
      if (event.target.files && event.target.files[0]) {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.onload = (e) => (this.imageSrc = reader.result);

        reader.readAsDataURL(file);
      }
    }
  }
}
